module.exports = __webpack_public_path__ + "components/country-flag/static/lr-31a3b1eb4104d9eb281b7c3090bf113e.svg";